@if (errorMessage) {
  <tidy-error-message [text]="errorMessage" />
}

@if (windowService.isDesktopRes) {
  <tidy-desktop-header [isLoading]="!loaded">
    <div class="wrappable-container allow-wrap">
      <tidy-text [header]="'Leases'" />
      <form [formGroup]="searchForm" novalidate action="#">
        <tidy-search-input
          formControlName="search"
          [placeholder]="'Search'"
          [icon]="'assets/img/search-header.svg'"
          class="header-search" />
      </form>
      <tidy-text
        [helper]="'Every active lease and its running balance. Open a lease for the full ledger — rent, late fees, payments, and balance owed.'" />
    </div>
    <div class="non-wrappable-right-aligned-container">
      <automations-preview-button
        [tag]="'leases'" />
    </div>
  </tidy-desktop-header>
}

@if (!loaded) {
  @for (i of [1,2,3,4]; track i) {
    <div style="width: 100%; margin-bottom: 6px;">
      <ion-skeleton-text animated="true" style="height: 48px; border-radius: 4px" />
    </div>
  }
}

@if (loaded) {

  @if (!windowService.isDesktopRes) {
    <form [formGroup]="searchForm" novalidate action="#" style="margin-bottom: 10px;">
      <tidy-search-input
        formControlName="search"
        [placeholder]="'Search leases'"
        [icon]="'assets/img/search-header.svg'"
        [fixedWidth]="false"
        class="header-search" />
    </form>
  }

  @if (windowService.isDesktopRes) {
    @if (shownRows.length > 0) {
      <tidy-card class="no-padding">
        <tidy-table
          #tidyTable
          [dataSource]="shownRows"
          [displayedColumns]="headers"
          [columnslabels]="headers"
          [allRowIsClickable]="true"
          [enableVirtualScrolling]="false"
          [showColumnLines]="false"
          (cellClick)="onRowClick($event)"
          [blockSorting]="true" />
      </tidy-card>
    }
    @if (shownRows.length === 0) {
      <tidy-alert><tidy-row><tidy-text [body]="emptyStateMessage" /></tidy-row></tidy-alert>
    }
  }

  @if (!windowService.isDesktopRes) {
    @for (view of shownLeaseViews; track view.lease.id) {
      <tidy-card (click)="onRowClick({ column: '', element: { id: view.lease.id } })">
        <tidy-row [alignLastItemRight]="true">
          <tidy-text [header]="view.lease.tenant_name" [translate]="false" />
          <tidy-text [body]="balanceLabel(balanceFor(view.lease))" [translate]="false" [ngStyle]="{ color: balanceColor(balanceFor(view.lease)) }" />
        </tidy-row>
        <tidy-row class="vertical-align-center">
          <tidy-image [src]="'assets/svg/home-outline.svg'" class="body-size" />
          <tidy-text [helper]="view.propertyLabel" [translate]="false" />
        </tidy-row>
        <tidy-row [alignLastItemRight]="true">
          <tidy-text [helper]="view.rentLabel + (view.lease.cadence === 'weekly' ? '' : '/mo')" [translate]="false" />
          <tidy-text [helper]="view.lease.status" [translate]="false" [ngStyle]="{ color: statusColor(view.lease.status) }" />
        </tidy-row>
      </tidy-card>
    }
    @if (shownLeaseViews.length === 0) {
      <tidy-alert><tidy-row><tidy-text [body]="emptyStateMessage" /></tidy-row></tidy-alert>
    }
  }
}
